module.exports = __webpack_public_path__ + "img/chongci_ps_14.4842d3b2.jpg";